<script setup lang="ts">
  import {useI18n} from 'vue-i18n';
  import useCpBem from '~/composables/useCpBem';
  import CpSectionHeader from '~/components/cp/CpSection/CpSectionHeader/CpSectionHeader.vue';
  import CpButton from '~/components/cp/CpButton/CpButton.vue';
  import CpIconStandard from '~/components/cp/CpIcon/CpIconStandard/CpIconStandard.vue';
  import CpText from '~/components/cp/CpText/CpText.vue';

  defineProps<{
    mainSpecs: Array<{ title: string; value: string }>,
  }>();
  defineEmits<{
    (e:'show-full-specs'): void
  }>();
  const {b, e} = useCpBem('cp-section-pdp-characteristics');
  const {t} = useI18n();
</script>

<template>
    <div v-if="mainSpecs.length>1" :class="b">
        <CpSectionHeader
            :title="t('characteristics')"
            type="h2"
        />
        <div :class="e('info-box')">
            <div :class="e('info-row-container')">
                <div
                    v-for="(spec, index) in mainSpecs"
                    :key="index"
                    :class="e('info-row')"
                >
                    <CpIconStandard
                        icon="chevron_right"
                    />
                    <CpText variant="heading-h3-pdp">
                        <CpText variant="body-bold">
                            {{ spec.title }}:
                        </CpText>
                        {{ spec.value }}
                    </CpText>
                </div>
            </div>
            <CpButton
                :label="t('seeSpecs')"
                kind="label"
                color="primary"
                hollow
                full-width
                type="button"
                @click="$emit('show-full-specs')"
            />
        </div>
    </div>
</template>

<style scoped lang="scss">
  .cp-section-pdp-characteristics {
    display: flex;
    flex-direction: column;
    &__info-box {
      padding: 16px;
      display: flex;
      flex-direction: column;
    }
    &__info-row {
      display: flex;
      align-items: center;
      gap: 4px;
    }
    &__info-row-container {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding-bottom: 16px;
    }
  }
</style>
<i18n locale="es-US">
  characteristics: "Características"
  seeSpecs: "Ver especificaciones completas"
</i18n>
